import { computed } from "vue";
import { useRoute } from "vue-router";
import { useQuery } from "@tanstack/vue-query";
import { listRepairsQuery } from "@vendata/power-up-sdk/requests/repairs/list";
import { statusFromQuery } from "./Repairs.logic.ts";

export function useRepairsLoader() {
  const route = useRoute();
  const status = computed(() => statusFromQuery(route.query));

  return {
    repairsQuery: useQuery(listRepairsQuery({ status })),
  };
}
